import { useEffect, useRef, useState } from "react"
import { DataReceivingPacketWrapper, DataReceivingWrapper, DataSendingAndReceivingWrapper, DataSendingWrapper, FilterItemLabel, GatewayDataDebugWrapper, PacketData, PacketTime, ToolBarLeftWrapper, ToolBarRightWrapper, ToolBarWrapper } from "./GatewayDataDebug.styled"
import { Button, Flex, Input, Select, Space, message } from "antd"
import GatewayApi from "../../../../../../api/GatewayApi"
import TimeUtils from "../../../../../../util/TimeUtils"
import ByteUtils from "../../../../../../util/ByteUtils"
import StringUtils from "../../../../../../util/StringUtils"
import { FilterItem } from "../../../../../device-management/components/device-details/components/history-device-metrics/HistoryDeviceMetrics.styled"
import Base64Utils from "../../../../../../util/Base64Utils"


interface GatewayDataDebugProps {
    gatewayView: any
}

let GatewayDataDebug: React.FC<GatewayDataDebugProps> = (props) => {
    const { gatewayView } = props

    // api
    let gatewayApi = new GatewayApi();
    let [messageApi, contextHolder] = message.useMessage();

    // state
    const [gatewayPortOptions, setGatewayPortOptions] = useState<any[]>([]);
    const [selectedPort, setSelectedPort] = useState<string>("");
    const [packets, setPackets] = useState<any[]>([]);
    const [sendingContent, setSendingContent] = useState<string>("");
    const [sendingBytes, setSendingBytes] = useState<number[]>([]);
    const [sendingEnabled, setSendingEnabled] = useState<boolean>(false);
    const [tx, setTx] = useState<number>(0);
    const [rx, setRx] = useState<number>(0);
    const packetsRef = useRef<any[]>([]);
    const txRef = useRef<number>(0);
    const rxRef = useRef<number>(0);

    let loadPackets = async ()=> {
        let packets = packetsRef.current;
        let packetMap = {}; 
        packets.forEach(e=> {
            packetMap[e.id] = e;
        });
        let newTx = txRef.current;
        let newRx = rxRef.current;
        let txRxPackets = (await gatewayApi.getRawTransferTxRxPackets(gatewayView.gateway.id, selectedPort)).data.data;
        txRxPackets.forEach(e=> {
            e.payload = Base64Utils.base64ToArrayBuffer(e.payload);
            if (!packetMap[e.id]) {
                packets.push(e);
                if (e.direction == 'UP') {
                    newRx += e.payload.length;
                } else {
                    newTx += e.payload.length;
                }
            }
        });
        setPackets([...packets]);
        setTx(newTx);
        setRx(newRx);
        txRef.current = newTx;
        rxRef.current = newRx;
    };

    let onPortChange = (value: string) => {
        setSelectedPort(value);
    };

    let onSendingContentChange = (e: any) => {
        let sendingContent = e.target.value;
        setSendingContent(sendingContent);
        if (sendingContent) {
            let valid = true;
            let sendingBytes = sendingContent.trim().split(' ').map((hex) => {
                let b = parseInt(hex, 16);
                if (isNaN(b) || b < 0 || b > 255) {
                    valid = false;
                }
                return b;
            });
            if (!valid) {
                setSendingEnabled(false);
                messageApi.error('发送内容必须是16进制字符串，且每个字节的范围是0-255');
            } else {
                setSendingBytes(sendingBytes);
                setSendingEnabled(true);
            }
        } else {
            setSendingBytes([]);
            setSendingEnabled(false);
        }
    };

    let onClear = async ()=> {
        // clear server packets
        await gatewayApi.clearRawTransferPackets({
            gatewayId: gatewayView.gateway.id,
            portName: selectedPort,
        });

        // reset packets and counters
        packetsRef.current = [];
        txRef.current = 0;
        rxRef.current = 0;
        setPackets([]);
    };

    let onSend = async () => {
        await gatewayApi.sendRawTransferPacket({
            gatewayId: gatewayView.gateway.id,
            portName: selectedPort,
            payload: sendingBytes
        });
    };

    useEffect(()=> {
        let productSpecification = JSON.parse(gatewayView.product.specification);
        let productResources = productSpecification.productResources;
        let gatewayPortOptions = [];
        for (let productResource of productResources) {
            if (productResource.type == 'UART') {
                for (let i=1; i <= productResource.quantity; i++) {
                    let portName = 'UART-' + i
                    gatewayPortOptions.push({
                        label: portName,
                        value: portName
                    });
                }
            }
        }
        setGatewayPortOptions(gatewayPortOptions);
        setSelectedPort(gatewayPortOptions[0].value);
    }, []);

    useEffect(()=> {
        if (!selectedPort) {
            return;
        }
        // reset packets and counters
        packetsRef.current = [];
        txRef.current = 0;
        rxRef.current = 0;

        // load packets
        let refreshPackets = async ()=> {
            try {
                await loadPackets();
            } catch (e) {
                console.log(e);
            }
            refreshPacketsTask = setTimeout(refreshPackets, 1000);
        };
        let refreshPacketsTask = setTimeout(refreshPackets, 1000);
        return ()=> {
            clearInterval(refreshPacketsTask);
        };
    }, [selectedPort]);

    return <GatewayDataDebugWrapper>
        {contextHolder}
        <ToolBarWrapper>
            <ToolBarLeftWrapper>
                <Space size="middle">
                    <FilterItem>端口：</FilterItem>
                    <FilterItem>
                        <Select
                            placeholder="请选择端口"
                            onChange={onPortChange}
                            options={gatewayPortOptions}
                            value={selectedPort}
                        />
                    </FilterItem>
                    <FilterItem></FilterItem>
                    <FilterItem>格式：HEX</FilterItem>
                    <FilterItem>RX: {rx}</FilterItem>
                    <FilterItem>TX: {tx}</FilterItem>
                </Space>
            </ToolBarLeftWrapper>

            <ToolBarRightWrapper>
                <Space size="middle">
                </Space>
            </ToolBarRightWrapper>
        </ToolBarWrapper>

        <DataSendingAndReceivingWrapper>
            <DataReceivingWrapper>
                {
                    packets.map((packet) => {
                        return <DataReceivingPacketWrapper key={packet.id} style={{alignItems: packet.direction == 'DOWN' ? 'flex-end' : 'flex-start'}}>
                            <PacketData>{ByteUtils.bytesToHex(packet.payload)}</PacketData>
                            <PacketTime>{TimeUtils.formatTimestamp(packet.timestamp, 'YYYY-MM-DD HH:mm:ss')}</PacketTime>
                        </DataReceivingPacketWrapper>
                    })
                }
            </DataReceivingWrapper>
            <DataSendingWrapper>
                <Input.TextArea placeholder="请输入字节对应的HEX格式数据，用空格分隔" style={{height: '100px', borderRadius: '0px', marginBottom: '10px'}} onChange={onSendingContentChange}/>
                <Flex justify="flex-end">
                    <Space size="middle">
                        <Button type="primary" danger onClick={onClear}>清空</Button>
                        <Button type="primary" disabled={!sendingEnabled} onClick={onSend}>发送</Button>
                    </Space>
                </Flex>
            </DataSendingWrapper>
        </DataSendingAndReceivingWrapper>
    </GatewayDataDebugWrapper>
};

export default GatewayDataDebug;
